<template>
  <div id='xiaolonglong' :toiframe='toiframe' :awardIdPointer='awardIdPointer'>
    <div id="mask"></div>
    <div class='converCon'>
      <p class='tip'>
        <b class='spanCon'>
          <span class='tipRight'></span>
          <span class='tipLeft' style='left:0;'></span>
        </b>
        <b class='spantip'>{{uiTitle}}</b>
        <span class='tipRight'></span>
        <span class='tipLeft'></span>
      </p>
      <ul class='top' style="margin-top:0.2rem;">
          <li :class="index == indexTab ? 'select' :''"
              v-for='(item,index) in awardList' 
              :key='index' 
              :awardId='item.awardId' 
              style="position:relative;"
              @click='selectTab(index,item.awardId,item.awardQuantity,item.awardName)'>
            <p class='pIcon'><img :src='item.icon'></p>
            <p class='styleCash' v-if='item.awardName == "现金"'>{{item.awardQuantity/100+'元'}}{{item.awardName}}</p>
            <p class='styleCash' v-if='item.awardName == "金币"'>{{item.awardQuantity}}{{item.awardName}}</p>
            <p class='styleCash' v-if='item.awardQuantity == "1" && item.awardName != "现金" && item.awardName != "金币"'>{{item.awardName}}</p>
          </li>
      </ul>
      <div class='bottom'>
        <p class='surplus'>
          <!-- 判断两个都不等于-1 -->
          <span v-if='convertData.dailySerplus !=-1 && convertData.allSerplus !=-1'>
            今日全员剩余：
            <b class='redC' v-if="convertData.dailySerplus <= convertData.allSerplus">{{convertData.dailySerplus }}个</b> 
            <b class='redC' v-else>{{convertData.allSerplus }}个</b> 
          </span>
          <span v-else-if='convertData.dailySerplus ==-1 || convertData.allSerplus ==-1'>
            <b class="redC" v-if="convertData.dailySerplus == -1 && convertData.allSerplus != -1">今日全员剩余：{{convertData.allSerplus}}</b>
            <b class="redC" v-else-if="convertData.allSerplus ==-1 && convertData.dailySerplus != -1">今日全员剩余：{{convertData.dailySerplus}}</b>
          </span>
          <!-- 右边的个人兑换 -->
          <span class='surRight' v-if='convertData.personalSerplus !=-1'>
            活动中个人可兑换
            <b class='redC' style="margin-left:0.05rem;font-weight: 400;">
              {{convertData.personalSerplus == 0 ? convertData.personalQuantity : convertData.personalQuantity-convertData.personalSerplus}}/{{convertData.personalQuantity}}
            </b>
          </span>
        </p>
        <ul class='change'>
          <li v-for='(item,ind) in deductList' :key="ind">
            <div class="iconImg">
                <div class='con'>
                    <img :src="item.icon" alt="">
                    <span class='spanName'>{{item.deductName}}</span>
                </div>
            </div>
            <p class='deductNameG' v-if='item.num >= item.deductQuantity'>
              {{item.propId =="CASH"?item.num/100:item.num }}/{{item.propId =="CASH"?item.deductQuantity/100:item.deductQuantity}}
            </p>
            <p class='deductName' v-if='item.num < item.deductQuantity'>
              {{item.propId =="CASH"?item.num/100:item.num }}/{{item.propId =="CASH"?item.deductQuantity/100:item.deductQuantity}}
            </p>
          </li>
        </ul>
      </div>
      <p class='warn' v-if='warntip != "" && (convertData.convertStatus==0 || convertData.convertStatus==1 || convertData.convertStatus==3)'>{{warntip}}</p>
      <div class='button exchange' :class='convertData.convertStatus==0 || convertData.convertStatus==1 || convertData.convertStatus==3  ?"exchangeNot":""'
        @click='convert'>兑换{{converTip}}</div>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import {mapState,mapMutations} from 'vuex'
  import config from "@/../config"
  import qs from 'qs'
  import active from '@/utils/axios/index'

  export default {
      data(){
        return {
          uiTitle:'',
          awardList: {},//兑换获得的东西
          converTip: '',//兑换按钮显示文字，根据奖品name变化
          deductList: {},//兑换奖品所需道具信息
          convertData: {},//兑换状态(个人的，全部的，当天的)‘
          warntip: '',//按钮上面的提示文字
          indexTab: 0,//切换兑换的详情展示
          isDisable: true,//不可以重复点击
          // deductList: {},//兑换奖品所需道具信息
          // convertData: {},//兑换状态
        }
      },
      computed:{
        ...mapState([
          'uuid',
          'activityStatus',
          'activityId',
          'cashcount',
          'goldcount',
          'activeBagMap',
          'time',
          'guide'
        ])
      },  
      created () {
        this.getConversion();
      },
      watch:{
        activeBagMap(){
          this.show()
        }
      },
      methods: {
        getConversion() {
          active.getConversion(config.API_HOST +'/apiserv/api/award/getConversion', qs.stringify({
            awardIdPointer: this.awardIdPointer,
            uuid: this.uuid,
            activityId: this.activityId
          })).then((res) => {
            if (res.return_code == 200) {
              this.uiTitle = res.data.uiTitle;//标题
              this.awardList = res.data.awardList;//兑换的奖励的列表
              //判断按钮展示的文本（道具现金金币）
              if (res.data.awardList[0].awardQuantity == 1 && res.data.awardList[0].awardName != '现金' && res.data.awardList[0].awardName != '金币') {
                this.converTip = res.data.awardList[0].awardName
              } else {
                if (res.data.awardList[0].awardName == '现金') {
                  this.converTip = res.data.awardList[0].awardQuantity / 100 + '元' + res.data.awardList[0].awardName;
                } else {
                  this.converTip = res.data.awardList[0].awardQuantity + '' + res.data.awardList[0].awardName;
                }
              }
              //需要加载第一个奖品的详情
              this.convertDetail(res.data.awardList[0].awardId)
            } else {
              this.tipConshow(res.return_msg)
            }
          })
        },
        //需要兑换的条件的展示
        convertDetail(awardId) {
          active.convertDetail(config.API_HOST +'/apiserv'+ '/api/award/convertDetail', qs.stringify({
            awardIdPointer: awardId,//兑换物品的awardIdPointer字段
            uuid: this.uuid,
            activityId: this.activityId//模板id
          })).then((res) => {
            if (res.return_code == 200) {
              this.deductList = res.data.deductList
              this.convertData = res.data.convertData
              this.show()
            } else {
              this.tipConshow(res.return_msg)
            }
          })
        },
        show(){
          // 更新页面中道具数量
          for(var i = 0; i < this.deductList.length; i++){
            if(this.deductList[i].propId =='GOLD'){
              this.deductList[i].num = this.goldcount
            }else if (this.deductList[i].propId == 'CASH') {
              this.deductList[i].num = this.cashcount
            } else {
              if (!this.activeBagMap[this.deductList[i].propId]) {
                this.deductList[i].num = 0
              } else {
                this.deductList[i] ? this.deductList[i].num = this.activeBagMap[this.deductList[i].propId].propNum : ""
                this.deductList = [...this.deductList];
              }
            }
          }
          //根据convertData.convertStatus显示不同的提示信息
          for (var i = 0; i < this.deductList.length; i++) {
            if (this.convertData.convertStatus == 0 || this.convertData.convertStatus == 1 || this.convertData.convertStatus == 2) {
              if (this.deductList[i].num < this.deductList[i].deductQuantity) {
                this.convertData.convertStatus = 0;
				this.warntip = '道具数量不足，无法兑换' + this.converTip;
				break;
			  } else {
				if (this.convertData.personalSerplus == 0 && this.convertData.dailySerplus != 0) {
				  this.warntip = '兑换次数已用完,每人可兑换'+ this.convertData.personalQuantity + '个' + this.converTip + '；';
				  this.convertData.convertStatus = 1;
				} else if (this.convertData.dailySerplus != 0 && this.convertData.dailySerplus == 0) {
				  this.warntip = '今日'+ this.converTip + '已兑换完，请明天再来；';
				  this.convertData.convertStatus = 1;
				} else if (this.convertData.dailySerplus == 0 && this.convertData.dailySerplus == 0) {
				  this.warntip = '请明天再来，今日兑换已达上限';
				  this.convertData.convertStatus = 1;
				}
			  }
			}
          }
        },
        //点击奖励选项获得相应的道具兑换条件
        selectTab(i, awardId, awardQuantity, awardName) {
          this.indexTab = i;//展示不同的使用道具的详情
          if (awardQuantity == 1 && awardName != '现金' && awardName != '金币') {   
            this.converTip = awardName;
          } else {
            if (awardName == '现金') {
              this.converTip = awardQuantity / 100 + '元' + awardName;
            } else {
              this.converTip = awardQuantity + '' + awardName;
            }
          }
          this.convertDetail(awardId)
        },
        //点击兑换奖品start（防止多次点击，根据返回的activityStatus判断活动状态，子龙对接）
        convert() {
          //防止多次点击
          if(this.isDisable){
            this.isDisable = false
            var convertAward = $('.select').attr('awardId')//选中的奖品的awardId
            if (this.activityStatus == 1) {//活动期间
              active.convert(config.API_HOST +'/apiserv/api/award/convert', qs.stringify({
                awardIdPointer: convertAward,
                uuid: this.uuid,
                activityId: this.activityId
              })).then((res) => {
                if (res.return_code == 200) {
                  this.convertData = res.data.convertData
                  var convertStatus = this.convertData.convertStatus
                  if (convertStatus == 2) {//成功兑换
					this.$tea('event_activemodal_converbtn_20101', { 'convertStatus': convertStatus, 'activityId': this.activityId, 'awardIdPointer': convertAward, guide:this.guide?this.guide:false });//数据埋点
                    // 成功兑换时需要对所拥有的道具做实时删减,循环从缓存里拿出的拥有道具，然后减去兑换时消耗的道具
                    for (var a of this.deductList) {
                      a.num -= parseInt(a.deductQuantity)
                      this.activeBagMap[a.propId].propNum -= parseInt(a.deductQuantity)
                    }
                    this.$store.commit({
                      type:'setactivebagmap',
                      activeBagMap:this.activeBagMap
                    })
                    var awardList = res.data.awardList
					if (typeof Android != 'undefined') { //运行环境为小游戏才需要执行
						// 调用安卓的方法进行金币，现金
						for (var i = 0; i < awardList.length; i++) {
						  if (awardList[i].awardName == '现金') {
						    Android.addUserBalance(awardList[i].awardQuantity / 100, 'CASH')
						  } else if (awardList[i].awardName == '金币') {
						    Android.addUserBalance(awardList[i].awardQuantity, 'GOLD')
						  }
						}
					}
                    // 领取奖励进行展示
                    this.tipConshow2(res.data.awardList)
                  } else {
                    if (convertStatus == 0) {
                      this.$tea('event_activemodal_converbtn_20101', { 'convertStatus': convertStatus, 'activityId': this.activityId, 'awardIdPointer': convertAward, guide:this.guide?this.guide:false });//数据埋点
                      this.tipConshow('道具不足，是否前往获取',this.toiframe, this.awardIdPointer);
                    } else if (convertStatus == 1) {
                      this.tipConshow('本次活动该兑换选项已经达到个人兑换上限，请兑换其他物品')
                    } else if (convertStatus == 3) {
                      this.tipConshow("兑换失败")
                    }
                  }
                } else {
                  this.tipConshow(res.return_msg)
                }
              })
            } else {
              //不是活动期间的提示信心及相应埋点
              if (parseInt(this.activityStatus) == 0) {
                this.tipConshow('【' + this.time + '】开启活动，请耐心等待')
                this.$tea('event_activemodal_ffconverbtn_20101', { 'activityId': this.activityId, 'awardIdPointer': convertAward, guide:this.guide?this.guide:false });//数据埋点
              } else if (parseInt(this.activityStatus) == 2) {
                this.tipConshow('活动已结束，请等待下次活动')
                this.$tea('event_activemodal_ffconverbtn_20101', { 'activityId': this.activityId, 'awardIdPointer': convertAward, guide:this.guide?this.guide:false });//数据埋点
              } else {
                this.tipConshow('活动已关闭，请等待下次活动')
                this.$tea('event_activemodal_ffconverbtn_20101', { 'activityId': this.activityId, 'awardIdPointer': convertAward, guide:this.guide?this.guide:false });//数据埋点
              }
            }
          }
          //延迟一秒之后可以再次点击进行兑换
          setTimeout(() => {
            this.isDisable = true
          }, 1000)
        }
      }
  }
</script>
<style scoped  lang="less">
button, p{
	margin: 0;
	padding: 0;
}
img {
  width: 100%;
  border-radius: 0.06rem;
}
#xiaolonglong {
  background: #fff;
  width: 100%;
  height: 4.3rem;
  border-radius: 0.05rem;
  box-sizing: border-box;
  color: lightslategray;
  background: url('~assets/images/head1.png') no-repeat top;
  background-size: contain;
  position:relative;
  margin-top:0.2rem;
}
#mask{
  position: absolute;
  width: 92%;
  height: 90%;
  left: 4%;
  top: 0.255rem;
  z-index: 10;
  border-radius: 0 0 0.12rem 0.12rem;
  z-index: 10;
  // background: rebeccapurple;
  display: none;
}
.converCon {
  width: 92%;
  position: absolute;
  top:0.23rem;
  left: 4%;
  border: 0.02rem solid #FDCB18;
  background: #FFF;
  border-bottom-left-radius: 0.12rem;
  border-bottom-right-radius: 0.12rem;
  border-top: none;
}
.tip {
  background: #FFD7AF;
  width: 100%;
  height: 0.36rem;
  font-size: 0.18rem;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: #F06712;
  line-height: 0.36rem;
  text-align: center;
}
.spanCon {
  display: inline-block;
  width: 0.3rem;
  height: 100%;
  position: relative;
  margin-right: -0.14rem;
}
.tip span{
  display: inline-block;
  width:0.04rem;
  background:#FFB856;
  border-radius: 0.1rem;
}
.spantip {
  margin: 0 0.1rem;
  font-weight: 400;
  font-size: 0.12rem;
}
.tipRight{
  height:0.15rem;
}
.tipLeft{
  height:0.2rem;
  margin-right: 0.05rem;
  margin-left:0.05rem;
  position: absolute;
  top:0.06rem;
}
.top {
  margin-top: 0.2rem;
  width: 3.05rem;
  height: 0.76rem;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.08rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.top li {
  height: 100%;
  width: 25%;
  list-style: none;
  border-radius: 0.04rem;
  text-align: center;
  border-right: 0.01rem solid rgba(192, 91, 2, 0.13);
  box-shadow: 0.03rem 0 0.05rem 0 rgba(192, 91, 2, 0.13);
  padding: 0.08rem 0;
  position: relative;
  overflow: hidden;
}
.top li.select {
  background: transparent url('~assets/images/selsect.png') center left;
  background-size: 109%;
  box-shadow: none;
  color: rgba(255, 86, 89, 1);
}
.top li.select p {
  color: rgba(200, 77, 0, 1);
}
.pIcon {
  width: 0.32rem;
  height: 0.32rem;
  font-size: 0.12rem;
  text-align: right;
  margin: 0 auto;
}
.styleCash {
  width: 100%;
  height: 0.13rem;
  text-align: center;
  line-height: 0.13rem;
  font-size: 0.13rem;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 400;
  color: rgba(200, 77, 0, 1);
  margin-top: 0.06rem;
  font-weight: 500;
}
.bottom {
  height: 1.34rem;
  width: 3.04rem;
  background: rgba(253, 246, 221, 1);
  border-radius: 0.06rem;
  margin: 0.16rem auto;
  padding: 0.16rem 0.08rem;
}
.bottom .surplus {
  font-size: 0.12rem;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 0.12rem;
}
.redC {
  color: rgba(250, 88, 76, 1);
  line-height: 0.12rem;
  font-weight: 400;
}
.surRight {
  float: right;
}
.change {
  width: 100%;
  height: 0.6rem;
  display: flex;
  margin-top: 0.15rem;
}
.change li {
  height: 0.7rem;
  flex: 1;
  margin-left: 0.02rem;
  border-radius: 0.05rem;
  list-style: none;
  text-align: center;
  font-size: 0.14rem;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 0.15rem;
  position: relative;
  margin: auto;
}
.iconImg {
  position: relative;
}
.con {
  width: 0.6rem;
  height: 0.6rem;
  margin: auto;
  position: relative;
  background: #fff;
  border-radius: 0.06rem;
}
.con img{
  width: 0.6rem;
  height: 0.6rem;
  position: relative;
}
.spanName {
    direction: block;
    position: absolute;
    width: 0.6rem;
    bottom: 0;
    left: 0;
    height: 0.16rem;
    background: rgba(0, 0, 0, .5);
    font-size: 0.12rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    border-bottom-left-radius: 0.06rem;
    border-bottom-right-radius: 0.06rem;

}

p.deductNameG {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 400;
  color: rgba(51, 201, 137, 1);
  font-size: 0.13rem;
  text-align: center;
}
p.deductName {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 400;
  color: rgba(250, 88, 76, 1);
  font-size: 0.12rem;
  text-align: center;
}
.warn {
  margin-top: 0.12rem;
  width: 100%;
  height: 0.28rem;
  line-height:0.28rem;
  text-align: center;
  font-size: 0.12rem;
  font-weight: 400;
  color: rgba(228, 15, 15, .7);
  margin-bottom: 0;
}
.button{
  border:0;
}
.button:active {
  transform: scale(0.9)
}
.exchange {
  width: 2.4rem;
  height:0.4rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  background: rgba(255, 142, 31, 1);
  box-shadow: 0 0.03rem 0 0 rgba(240, 92, 0, 1), 0 0 0 0 rgba(255, 247, 227, 0.5);
  border-radius: 0.2rem;
  font-size: 0.12rem;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 0.4rem;
  text-align: center;
  margin-left: 0.45rem;
  display: block;
}
.exchangeNot {
  background: rgba(221, 221, 221, 1);
  box-shadow: 0 0.03rem 0 0 rgba(179, 179, 179, 1), 0 0 0 0 rgba(255, 255, 255, 0.5);
}
@keyframes white {
  20%{
    background: rgba(238, 238, 238, 1);
  }
  50%{
    background: rgba(238, 238, 238, 0);
  }
  75%{
    background: rgba(238, 238, 238, 1);
  }
  100%{
    background: rgba(238, 238, 238, 0)
  }
}
</style>